import { factory } from '@repo-level/core-front';

export interface IUserStorageItem<Info = object> {
  identifier: string;
  info: Info;
  createdAt: string;
  updatedAt: string;
}

export const userStorageItems = factory(
  (r) => () =>
    r<{ data: IUserStorageItem[] } | IUserStorageItem[]>(
      'get',
      'user_storage_items'
    )
);

/** the endpoint returns either a bare list or `{ data: list }` */
export const getUserStorageList = (
  data: { data: IUserStorageItem[] } | IUserStorageItem[]
) => (Array.isArray(data) ? data : (data?.data ?? []));

export const setUserStorageItems = factory(
  (r) => (data: Pick<IUserStorageItem, 'identifier' | 'info'>[]) =>
    r<null>('post', 'user_storage_items', { data })
);

export const deleteUserStorageItems = factory(
  (r) => (data: string[]) =>
    r<null>('post', 'user_storage_items/delete', { data })
);
